import {
  addressSchema,
  addressUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

const updatedAddressSchema = addressSchema({
  omit: ['street3'],
  extend: {
    street: { maxLength: 30 },
    street2: { maxLength: 5 },
    city: { maxLength: 18 },
  },
});

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['your-address-title']),
    yourAddress: addressUI({
      labels: {
        street2: content['address-street-2'],
        militaryCheckbox: content['address-military-checkbox'],
      },
      omit: ['street3'],
    }),
  },
  schema: {
    type: 'object',
    required: ['yourAddress'],
    properties: {
      yourAddress: updatedAddressSchema,
    },
  },
};
